// Init axios ajax
var cordiaAPI = axios.create({
  baseURL: localize.apiendpoint,
});

const RECAPTCHA_SITE_KEY = localize.captcha_site_key;
const RECAPTCHA_PROTECTED_PATHS = [
  "/user/gdpr",
  "/newsletter/subscribe",
  "/sf/offers-sv",
  "/sf/investor",
];

// General button lock var for prevent double ajax calls
var buttonLock = false;

/* Check if is logged in */
var userToken = Cookies.get("token");

(function ($) {
  "use strict";

  $(function () {
    /* Init Object fit images polyfill */
    objectFitImages();
    objectFitVideos();

    $.langCookie = Cookies.get("_icl_current_language");
    if ($.langCookie == undefined) {
      $.langCookie = Cookies.get("wp-wpml_current_language");
    }

    /* Setting up facebook api */
    $.ajaxSetup({ cache: true });

    /* Validate phonenumber */
    $(document).on("input propertychange", ".js-telephone", function () {
      if ($(this).val().indexOf("+") === -1) {
        $(this).val("+" + $(this).val());
      }
    });

    $(document).on("keypress keyup blur", ".js-telephone", function (event) {
      $(this).val(
        $(this)
          .val()
          .replace(/[^0-9\+].+/, "")
      );
      if (event.which < 48 || event.which > 57) {
        event.preventDefault();
      }
    });
  });
})(jQuery);
